import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'soft-outlet',
  imports: [RouterOutlet],
  templateUrl: './outlet.component.html',
  styleUrl: './outlet.component.css',
})
export class OutletComponent {}
